// Add the Alpine.js components that provide client-only interactions here!
// This is all that is needed. The AlpineComponents.load() is invoked at the correct time in app.js

// Reusable (template) Rx Alpine components
import RxDataGrid from "../../../Components/Rx/DataGrid/RxDataGrid";
import RxDataGridDelete from "../../../Components/Rx/DataGrid/RxDataGridDelete";
import RxDataGridDeleteTrigger from "../../../Components/Rx/DataGrid/RxDataGridDeleteTrigger";
import RxDataGridPage from "../../../Components/Rx/DataGrid/RxDataGridPage";
import RxDataGridFilter from "../../../Components/Rx/DataGrid/RxDataGridFilter";
import RxDataGridFilterControl from "../../../Components/Rx/DataGrid/RxDataGridFilterControl";
import RxDataGridFooter from "../../../Components/Rx/DataGrid/RxDataGridFooter";
import RxDataGridSortColumn from "../../../Components/Rx/DataGrid/RxDataGridSortColumn";
import RxFileList from "../../../Components/Rx/FileList/RxFileList";
import RxInputFile from "../../../Components/Rx/InputFile/RxInputFile";
import RxInputTextArea from "../../../Components/Rx/InputTextArea/RxInputTextArea";
import RxModalDialogAdvanced from "../../../Components/Rx/ModalDialog/RxModalDialogAdvanced";
import RxModalDialogBasic from "../../../Components/Rx/ModalDialog/RxModalDialogBasic";
import RxModalDialogTrigger from "../../../Components/Rx/ModalDialog/RxModalDialogTrigger";
import RxPickerControl from "../../../Components/Rx/Picker/RxPickerControl";
import RxToast from "../../../Components/Rx/Toast/RxToast";
import RxUtcDateConverter from "../../../Components/Rx/UtcDateConverter/RxUtcDateConverter";

// Page-level Alpine components
import DataGridDemo from "../../../Components/Features/Demos/DataGrid/DataGridDemo";
import Inspections from "../../../Components/Features/Inspections/InspectionList/Inspections";

const AlpineComponents = {
    load: () => {
        Alpine.data("RxDataGrid", RxDataGrid);
        Alpine.data("RxDataGridDelete", RxDataGridDelete);
        Alpine.data("RxDataGridDeleteTrigger", RxDataGridDeleteTrigger);
        Alpine.data("RxDataGridPage", RxDataGridPage);
        Alpine.data("RxDataGridFilter", RxDataGridFilter);
        Alpine.data("RxDataGridFilterControl", RxDataGridFilterControl);
        Alpine.data("RxDataGridFooter", RxDataGridFooter);
        Alpine.data("RxDataGridSortColumn", RxDataGridSortColumn);
        Alpine.data("RxFileList", RxFileList);
        Alpine.data("RxInputFile", RxInputFile);
        Alpine.data("RxModalDialogAdvanced", RxModalDialogAdvanced);
        Alpine.data("RxModalDialogBasic", RxModalDialogBasic);
        Alpine.data("RxModalDialogTrigger", RxModalDialogTrigger);
        Alpine.data("RxInputTextArea", RxInputTextArea);
        Alpine.data("RxPickerControl", RxPickerControl);
        Alpine.data("RxToast", RxToast);
        Alpine.data("RxUtcDateConverter", RxUtcDateConverter);
        // Page Level
        Alpine.data("DataGridDemo", DataGridDemo);
        Alpine.data("Inspections", Inspections);
    },
};

export default AlpineComponents;
